export default __webpack_public_path__ + "static/media/general2024-1.89a559d2.gif";